export const useScrollToId =
  () =>
  (id: string, offset = 0, options?: ScrollToOptions) => {
    const el = document.getElementById(id);
    if (el) {
      const y = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({
        top: y,
        ...options,
      });
    }
  };
